import { Component, Input } from '@angular/core';
import {
  ClassroomMetrics,
  EngagementMetrics,
  ProfUserEngagementRow,
  OverviewTheme,
  OverviewQuestion,
  TrendDelta
} from '../../models/analytics.types';
import { PAGE_SIZE } from '../../models/period-trends.const';

@Component({
  selector: 'tangram-pa-learner-engagement-tab',
  templateUrl: './learner-engagement-tab.component.html',
  styleUrls: ['./learner-engagement-tab.component.scss']
})
export class LearnerEngagementTabComponent {
  @Input() classroomMetrics: ClassroomMetrics = {
    activeStudentsPct: 0,
    avgCompletionPerTangram: 0,
    avgTimePerTangram: '0m',
    avgTimePerContent: '0m'
  };
  @Input() engagementMetrics: EngagementMetrics = {
    commentsPerTangram: 0,
    pollCompletionRate: 0,
    questionCompletionRate: 0
  };
  @Input() userEngagementRows: ProfUserEngagementRow[] = [];
  @Input() topThemes: OverviewTheme[] = [];
  @Input() questionInsights: OverviewQuestion[] = [];
  @Input() trends: { [key: string]: TrendDelta } = {};

  readonly PAGE_SIZE = PAGE_SIZE;
  userEngagementPage = 1;

  trend(key: string): TrendDelta {
    return this.trends[key] || { delta: 0, unit: '' };
  }

  get pagedUserEngagement(): ProfUserEngagementRow[] {
    return this.userEngagementRows.slice(
      (this.userEngagementPage - 1) * this.PAGE_SIZE,
      this.userEngagementPage * this.PAGE_SIZE
    );
  }
}
